// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_ol-0";